import { ReactElement } from "react";
import { resolveProperty } from "@animech/axiom-utility";
import {
	FieldComponentBuilderArgs,
	FieldPipe,
	FieldPipeMeta,
	UiComponentBuildContext,
	UiComponentBuilder,
} from "@animech/axiom-ui-builder";
import { Root } from "@definitions";
import { AccordionNode } from "src/definitions/ui-definitions";
import { Accordion } from "src/ui/components/widgets/accordion";

export type ComponentBuilderArgs = FieldComponentBuilderArgs<
	Root,
	AccordionNode
>;

export class AccordionComponentBuilder
	implements UiComponentBuilder<Root, AccordionNode>
{
	private _args: ComponentBuilderArgs;

	constructor(args: ComponentBuilderArgs) {
		this._args = { ...args };
	}

	public build(node: AccordionNode, context: UiComponentBuildContext<Root>) {
		const { getFieldNodeMeta, getFieldNodeValueMeta } = this._args;

		if (node.state) {
			const property = resolveProperty(node.state, context.activeProperty);
			return (
				<FieldPipe key={`${node.id}`} property={property} write>
					<FieldPipeMeta
						getFieldMeta={(property) => getFieldNodeMeta(node, property)}
						getFieldValueMeta={getFieldNodeValueMeta}
					>
						{this._render(node, context)}
					</FieldPipeMeta>
				</FieldPipe>
			);
		} else {
			return this._render(node, context);
		}
	}

	private _render(
		node: AccordionNode,
		context: UiComponentBuildContext<Root>,
	): ReactElement {
		return <Accordion id={node.id}>{context.childElements}</Accordion>;
	}
}
